import { useTranslation } from "react-i18next";
import { MonitorSmartphone, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function TrustedDevicesPanel({ devices, onRevoke }) {
  const { t } = useTranslation();
  return (
    <>
      <p className="text-sm text-muted2 font-body mb-4">{t("devices.desc")}</p>
      {devices.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-2xl border border-border text-muted2 font-body">{t("devices.empty")}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {devices.map((d) => (
            <div key={d.id} data-testid={`device-${d.id}`} className="bg-white rounded-2xl shadow-card border border-border p-4 flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-canard/10 flex items-center justify-center text-canard shrink-0"><MonitorSmartphone className="w-5 h-5" /></div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-ink text-sm truncate">{d.user_agent || t("devices.unknownDevice")}</p>
                <p className="text-xs text-muted2 mt-0.5">{t("devices.added")} {d.created_at ? new Date(d.created_at).toLocaleDateString() : "—"} · {t("devices.expires")} {d.expires_at ? new Date(d.expires_at).toLocaleDateString() : "—"}</p>
                {d.current && <span className="inline-block mt-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-emeraude/15 text-emeraude-dark">{t("devices.current")}</span>}
              </div>
              <Button size="sm" variant="outline" data-testid={`revoke-device-${d.id}`} onClick={() => onRevoke(d.id)} className="rounded-full h-8 text-destructive border-destructive/30 shrink-0"><XCircle className="w-3.5 h-3.5 mr-1" /> {t("devices.revoke")}</Button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
